import React, {useState, useEffect} from "react";

export const RenderComponent = () => {
    const [renderComponent, setRenderComponent] = useState("false")

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (renderComponent === "false") {
                setRenderComponent("true")
            }
        })
        window.addEventListener("mousemove", () => {
            if (renderComponent === "false") {
                setRenderComponent("true")
            }
        })
        window.addEventListener("touchmove", () => {
            if (renderComponent === "false") {
                setRenderComponent("true")
            }
        })
        window.addEventListener("keypress", () => {
            if (renderComponent === "false") {
                setRenderComponent("true")
            }
        })
    }, [])

    //console.log("renderComponent", renderComponent)

    return renderComponent
}